import { FC } from "react";

import { Check, Warning } from "@livechat/design-system-icons";
import { Icon, Info, Tag, Tooltip } from "@livechat/design-system-react-components";

interface IProps {
  verified: boolean;
}

export const StatusBadge: FC<IProps> = ({ verified }) => {
  if (verified) {
    return (
      <Tooltip
        kind="invert"
        placement="top"
        triggerRenderer={
          <Tag
            kind="success"
            size="small"
            leftNode={<Icon source={Check} size="small" />}
            data-testid="reply-address-verified-badge"
          >
            Verified
          </Tag>
        }
      >
        <Info text="The reply address is verified properly, and emails from the entered email address are forwarded to HelpDesk. " />
      </Tooltip>
    );
  }
  return (
    <Tooltip
      kind="invert"
      placement="top"
      triggerRenderer={
        <Tag
          kind="warning"
          size="small"
          leftNode={<Icon source={Warning} size="small" />}
          data-testid="reply-address-not-verified-badge"
        >
          Not verified
        </Tag>
      }
    >
      <Info text="The reply address isn't verified yet, and emails from the entered email address aren't forwarded to HelpDesk." />
    </Tooltip>
  );
};
